<template>
  <div v-loading="loading">
    <div style="width: 168px; margin: 16px 16px 12px 16px">
      <el-input placeholder="搜索文件夹" suffix-icon="el-icon-search" class="filter" v-model="folderName"></el-input>
    </div>
    <div class="new-file-btn">
      <i class="el-icon-plus" @click="addFolder">新建文件夹</i>
    </div>
    <!-- <el-menu
      default-active="1"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
    >
      <el-menu-item :index="item.id" v-for="item in folder" :key="item.id">{{
        item.name
      }}</el-menu-item>
    </el-menu> -->
    <el-tree
      :data="folder"
      node-key="id"
      :props="defaultProps"
      @node-click="handleNodeClick"
      highlight-current
      :current-node-key="folder[0].id"
      ref="tree"
      :filter-node-method="filterNode"
      :default-expanded-keys="treeData"
      :default-checked-keys="selectedData"
    >
      <span class="custom-tree-node" slot-scope="{ node }">
        <svg-icon icon-class="folder1" class="svgIcon" />

        <span class="fontSize14" :title="node.label || '-'">{{ node.label }}</span>

        <el-popover popper-class="folderPop" placement="bottom" width="50" trigger="hover">
          <div class="folder-item" @click="deleteFolder(node)">删除文件</div>
          <div class="folder-item" @click="renameFolder(node)">重命名文件</div>
          <div class="folder-item" @click="newFolder(node)">新建文件夹</div>
          <svg-icon slot="reference" iconClass="dian" className="folder-opeara"></svg-icon>
        </el-popover>
      </span>
    </el-tree>
    <edit-material-modal ref="materialRef" @getFolder="getFolder" :folder="folder"></edit-material-modal>
    <delete-folder-modal ref="delRef" @updateFolder="updateFolder"></delete-folder-modal>
    <rename-folder-modal ref="renameRef" @updateFolder="updateFolder"></rename-folder-modal>
  </div>
</template>
<script>
import { getMaterialFetch } from "../../api/material";
import EditMaterialModal from "./editMaterialModal.vue";
import SvgIcon from "../../components/SvgIcon.vue";
import DeleteFolderModal from "./deleteFolderModal.vue";
import RenameFolderModal from "./renameFolderModal.vue";
export default {
  components: {
    EditMaterialModal,
    SvgIcon,
    DeleteFolderModal,
    RenameFolderModal,
  },
  data() {
    return {
      folder: [],
      treeData: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      folderName: "",
      selectedData: [],
      loading: false,
    };
  },
  mounted() {
    this.getFolder();
  },
  methods: {
    getFolder() {
      this.loading = true;
      getMaterialFetch()
        .then((res) => {
          this.folder = res.data;
          this.treeData = [res.data[0].id, res.data[1].id];
          this.selectedData = [25];
          this.$emit("saveFolderDetail", res.data[0]);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    addFolder() {
      this.$refs.materialRef.showModal();
    },
    handleNodeClick(data) {
      this.$emit("saveFolderDetail", data);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    deleteFolder(node) {
      this.$refs.delRef.showModal(node);
    },
    updateFolder() {
      this.getFolder();
    },
    renameFolder(node) {
      this.$refs.renameRef.showModal(node);
    },
    newFolder(node) {
      this.$refs.materialRef.showModal(node);
    },
  },
  watch: {
    folderName(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>
<style lang="less">
// .el-tree .el-tree-node__expand-icon.expanded {
//   transform: rotate(0deg);
// }
// .el-tree .el-icon-caret-right:before {
//   content: "\E602";
//   font-size: 18px;
// }
// .el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
//   content: "\E63c";
//   font-size: 18px;
// }
.el-tree .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

.el-tree .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

//有子节点 且未展开
.el-tree .el-icon-caret-right:before {
  background: url("../../assets/right.png") no-repeat 0 0px;
  content: "";
  display: block;
  width: 16px;
  height: 20px;
  font-size: 16px;
  background-size: 20px;
}

//有子节点 且已展开
.el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
  background: url("../../assets/bottom.png") no-repeat 0 0px;
  content: "";
  display: block;
  width: 16px;
  height: 19px;
  font-size: 16px;
  background-size: 20px;
}

//没有子节点
.el-tree .el-tree-node__expand-icon.is-leaf::before {
  background: transparent;
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 16px;
}
// 选中节点背景
.el-tree-node.is-current > .el-tree-node__content {
  background: rgba(24, 144, 255, 0.1);
  color: rgba(24, 144, 255, 1);
}
.el-tree-node__content:hover {
  background: rgba(24, 144, 255, 0.1);
}
.el-tree-node__content {
  height: 30px;
  position: relative;
  &:hover .folder-opeara {
    display: inline-block;
  }
}
.svgIcon {
  margin-right: 4px;
}
.new-file-btn {
  padding: 0 12px 12px 16px;
  cursor: pointer;
  font-size: 14px;
  color: rgba(24, 144, 255, 1);
}

.el-tree-node__expand-icon {
  padding-left: 12px !important;
}

.folder-opeara {
  position: absolute;
  top: 8px;
  right: 5px;
  display: none;
}
.folderPop {
  min-width: 100px;
  .folder-item {
    height: 24px;
    line-height: 24px;
    &:hover {
      background: rgba(24, 144, 255, 0.1);
      cursor: pointer;
    }
  }
}
</style>
